import { render, staticRenderFns } from "./SwapCalculator.vue?vue&type=template&id=655e1551&"
import script from "./SwapCalculator.vue?vue&type=script&lang=js&"
export * from "./SwapCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports